import React, { PureComponent, PropTypes } from 'react';
import moment from 'moment';

import { getStartEndTimesBasedOnBookingStatus } from '../../../util/bookingHelpers';

import Day from './Day';

import './DaySelector.css';

export default class DaySelector extends PureComponent {
    static propTypes = {
        start: PropTypes.object,
        end: PropTypes.object,
        minStartDate: PropTypes.object.isRequired,
        maxEndDate: PropTypes.object.isRequired,
        onDaySelected: PropTypes.func.isRequired,
    }

    render() {
        const {
            booking,
            start,
            end,
            minStartDate,
            maxEndDate,
        } = this.props;

        const startBounds = moment(minStartDate).startOf(`d`);
        const endBounds = moment(maxEndDate).endOf(`d`);

        const duration = moment.duration(endBounds.diff(startBounds));
        const days = Math.ceil(duration.asDays());

        let dayBlocksJsx = [];
        for (let i = 0; i < days; i++) {
            const day = moment(startBounds).add(i, `d`);

            dayBlocksJsx.push(
                <Day
                    day={day}
                    start={start}
                    end={end}
                    onClick={this.props.onDaySelected}
                    key={i}
                />
            );
        }

        return (
            <div className="day-selector">
                {dayBlocksJsx}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/Common/TimeSelector/DaySelector.jsx